import { apiX } from '.'

export const getAssets = () => apiX.get('v2/account/asset').json()
